<template>
  <v-flex data-qa="payeedetails-flex-og6n9j">
    <v-layout wrap class="ml-2 payee--gradientBGposition" data-qa="payeedetails-layout-fd6eys">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '170px' }"
        data-qa="payeedetails-flex-3afqc7"
      >
        <v-container class="payee--title-padding" data-qa="payeedetails-container-gf8t1g">
          <v-flex xs12 sm12 md12 lg12 xl12 class="ml-xs-auto ml-sm-9 ml-md-9 ml-lg-9 ml-xl-9" data-qa="payeedetails-flex-qj3xn">
            <v-row no-gutters data-qa="payeedetails-row-gryt7g">
              <v-layout row wrap class="pb-2" data-qa="payeedetails-layout-9d7k4l">
                <v-avatar :tile="false" size="35" color="white" data-qa="payeedetails-avatar-ndkbrd">
                  <v-icon :color="primaryColor" data-qa="payeedetails-icon-ek0h9s">
                    mdi-sync
                  </v-icon>
                </v-avatar>
                <font class="text-h5 font-weight-light white--text px-4">
                  <span v-if="appSettings.enableNominatedAccountFeatures && appSettings.enablePaymentsOnlyToNominatedAccounts" data-qa="payeedetails-span-gwct4k"> {{ $t('payeeDetails.ownAccountTitle') }} </span>
                  <span v-else data-qa="payeedetails-span-xjrg8r"> {{ $t('payeeDetails.title') }} </span>
                </font>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
      xs12
      sm12
      md12
      lg12
      xl12
      class="payee--content-padding payee--overlayCardFlex"
      data-qa="payeedetails-flex-cadi9l"
    >
      <v-layout row wrap class="payee--content-padding" data-qa="payeedetails-layout-oorgdd">
        <v-flex xs12 sm12 md11 lg10 xl8 class="pt-7" data-qa="payeedetails-flex-wvozs">
          <!-- Form start -->
          <v-card class="pt-10 px-8" data-qa="payeedetails-card-uzvefb">
            <v-row class="px-1" data-qa="payeedetails-row-by7e">
              <v-flex class="pa-3" xs12 sm12 md12 lg12 xl12 data-qa="payeedetails-flex-n31gj">
                <font class="text-h5 font-weight-light px-1">
                  <span v-if="appSettings.enableNominatedAccountFeatures && appSettings.enablePaymentsOnlyToNominatedAccounts" data-qa="payeedetails-span-674po"> {{ $t('payeeDetails.ownAccountTitle') }} </span>
                  <span v-else data-qa="payeedetails-span-v7vxg9"> {{ config.paymentSystem === 'SWIFT' ? $t('swiftPayments.payeeTitle') : $t('payeeDetails.title') }} </span>
                </font>
              </v-flex>
              <v-flex class="pa-3" xs12 sm6 md6 lg6 xl6 data-qa="payeedetails-flex-dzsbvg">
                <v-layout column wrap data-qa="payeedetails-layout-ewd2w8">
                  <v-flex xs6 sm4 md6 lg6 xl4 class="px-1" data-qa="payeedetails-flex-oa6gja">
                    <font class="overline font-weight-bold">
                      <span v-if="appSettings.enableNominatedAccountFeatures && appSettings.enablePaymentsOnlyToNominatedAccounts" data-qa="payeedetails-span-6w93h7"> {{ $t('payeeDetails.accountName') }} </span>
                      <span v-else data-qa="payeedetails-span-e48x6"> {{ $t('payeeDetails.fullName') }} </span>
                    </font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg6 xl4 class="px-1" data-qa="payeedetails-flex-su4y0e">
                    <font class="subheading-1 font-weight-medium">
                      {{ config.fullName }}
                    </font>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="pa-3" xs12 sm6 md6 lg6 xl6 data-qa="payeedetails-flex-2o36di">
                <v-layout column wrap data-qa="payeedetails-layout-1dhlf">
                  <v-flex xs6 sm4 md6 lg6 xl4 class="px-1" data-qa="payeedetails-flex-tdlyw">
                    <font class="overline font-weight-bold">
                      {{ $t('payeeDetails.accNo') }}
                    </font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg6 xl4 class="px-1" data-qa="payeedetails-flex-fg96l">
                    <font class="subheading-1 font-weight-medium">
                      {{ config.accNo }}
                    </font>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="pa-3" xs12 sm6 md6 lg6 xl6 data-qa="payeedetails-flex-o3go9">
                <v-layout column wrap data-qa="payeedetails-layout-laixov">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="payeedetails-flex-fqodyb">
                    <font class="overline font-weight-bold">
                      {{ $t('payeeDetails.currency') }}
                    </font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="payeedetails-flex-0b6fgs">
                    <font class="subheading-1 font-weight-medium">
                      {{ config.currency }}
                    </font>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex class="pa-3" xs12 sm6 md6 lg6 xl6 data-qa="payeedetails-flex-199k1m">
                <v-layout column wrap data-qa="payeedetails-layout-d22p7k">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="payeedetails-flex-d8dp4">
                    <font v-if="config.paymentSystem === 'STEP2' || config.paymentSystem === 'SWIFT' " class="overline font-weight-bold">
                      {{ $t('payeeDetails.bicCode') }}
                    </font>
                    <font v-else class="overline font-weight-bold">
                      {{ $t('payeeDetails.sortCode') }}
                    </font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="payeedetails-flex-x78h2n">
                    <font class="subheading-1 font-weight-medium">
                      {{ config.sortCode }}
                    </font>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-row
                v-if="config.paymentSystem === 'STEP2'
                  && isAddPayeeAddressEnabled
                "
                no-gutters
              >
                <v-col
                  v-for="(field, i) in Object.keys(payeeAddressDetailsConfig)"
                  v-show="config[field] && payeeAddressDetailsConfig[field]?.displayData"
                  :key="i"
                  class="pa-2"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                >
                  <v-col class="px-1">
                    <font class="overline font-weight-bold d-flex">
                      {{ $t(`payeeDetails.${field}`) }}
                    </font>
                    <font class="subheading-1 font-weight-medium d-flex">{{
                      field === 'addressType'
                        ? $t(`systemEnums.payeeDetails.${config[field]}`)
                        : field === 'country'
                          ? getCountryDesciption(config[field])
                          : config[field]
                    }}</font>
                  </v-col>
                </v-col>
              </v-row>
              <v-flex v-if="config.country && config.paymentSystem === 'SWIFT'" class="pa-3" xs12 sm6 md6 lg6 xl6>
                <v-layout column wrap>
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1">
                    <font class="overline font-weight-bold">
                      {{ $t('swiftPayments.payeeCountry') }}
                    </font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1">
                    <font class="subheading-1 font-weight-medium">
                      {{ getCountryDesciption(config.country) }}
                    </font>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-if="config.town" class="pa-3" xs12 sm6 md6 lg6 xl6>
                <v-layout column wrap>
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1">
                    <font class="overline font-weight-bold">
                      {{ $t('swiftPayments.payeeTown') }}
                    </font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1">
                    <font class="subheading-1 font-weight-medium">
                      {{ config.town }}
                    </font>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-if="config.postCode" class="pa-3" xs12 sm6 md6 lg6 xl6>
                <v-layout column wrap>
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1">
                    <font class="overline font-weight-bold">
                      {{ $t('swiftPayments.payeePostalCode') }}
                    </font>
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1">
                    <font class="subheading-1 font-weight-medium">
                      {{ config.postCode }}
                    </font>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-row>

            <!-- UDF Details -->
            <v-row
              v-if="enableUDFBeneficiaryForAddPayee && udfDetails?.length > 0"
              class="mt-8 px-1"
            >
              <v-col cols="12">
                <span
                  class="text-h5 font-weight-light px-1"
                  data-qa="payeedetails-span-suk1vz"
                >
                  {{ $t('payeeDetails.otherDetails') }}
                </span>
              </v-col>
              <v-col
                v-for="(item, index) in udfDetails"
                :key="item.key"
                class="pa-3"
                cols="12" sm="6"
              >
                <div class="d-flex flex-column">
                  <span
                    class="overline font-weight-bold"
                    :data-qa="`payeedetails-udf-label-${index}`"
                  >
                    {{ item.label }}
                  </span>
                  <span
                    class="subheading-1 font-weight-medium"
                    :data-qa="`payeedetails-udf-value-${index}`"
                  >
                    {{ item.value }}
                  </span>
                </div>
              </v-col>
            </v-row>

            <!-- View Linked Accounts-->
            <v-list v-if="ownLinkedAccounts && ownLinkedAccounts.length" class="mt-10 pt-10" subheader two-line data-qa="payeedetails-list-7yz2oh">
              <v-flex data-qa="payeedetails-flex-5wxy6o">
                <font class="text-uppercase mx-1 subheading-1 font-weight-bold">
                  {{ $t('payeeDetails.linkedAccountsTitle') }}
                </font>
              </v-flex>
              <template v-for="(account, index) in ownLinkedAccounts">
                <v-list-item :key="account.moduleReference" :data-qa="`payeedetails-list-item-4kxy2f-${index}`">
                  <v-row data-qa="payeedetails-row-060w37">
                    <v-flex xs12 sm12 md12 lg6 xl8 :data-qa="`payeedetails-flex-bwianl-${index}`">
                      <v-list-item-content
                        class=""
                        :data-qa="`payeedetails-list-item-content-d4w32a-${index}`"
                      >
                        <v-list-item-title
                          class="overline font-weight-bold"
                          :data-qa="`payeedetails-list-item-title-ycts1c-${index}`"
                        >
                          {{ getAccountName(account.module) }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                          :data-qa="`payeedetails-list-item-subtitle-ow4j2m-${index}`"
                        >
                          {{ account.moduleReference }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      lg6
                      xl4
                      class="mt-xs-auto mt-sm-auto mt-md-auto mt-lg-4 mt-xl-4 pl-4"
                      :data-qa="`payeedetails-flex-83lhqe-${index}`"
                    >
                      <v-list-item-action :data-qa="`payeedetails-list-item-action-z4dmo-${index}`">
                        <v-row :data-qa="`payeedetails-row-ptv8js-${index}`">
                          <v-btn
                            text
                            :color="primaryColor"
                            class="text-capitalize"
                            :data-qa="`payeedetails-btn-gvanws-${index}`"
                            @click="viewLinkedAccountDetails(account)"
                          >
                            {{ $t('payee.viewDetails') }}
                          </v-btn>
                        </v-row>
                      </v-list-item-action>
                    </v-flex>
                  </v-row>
                </v-list-item>
                <v-divider
                  v-if="index < ownLinkedAccounts.length - 1"
                  :key="index"
                  class="my-2 my-lg-auto my-xl-auto"
                  :data-qa="`payeedetails-divider-bgll1-${index}`"
                />
              </template>
            </v-list>
            <PayeeRelatedDocuments
              v-if="shouldDisplayRelatedDocuments && payeeDocuments?.items?.length > 0"
              :document-details="payeeDocuments.items"
              class="mt-8"
            />
            <PayeeRelatedDocuments
              v-if="selectedPayeeDetails.paymentSystem === 'SWIFT' && payeeDocuments?.items?.length > 0"
              :document-details="payeeDocuments.items"
              class="mt-8"
            />
            <!-- Form Actions Start -->
            <v-card-actions class="pt-8 pb-4">
              <v-btn
                outlined
                :color="primaryColor"
                class="text-none py-2 px-4"
                data-qa="payeedetails-btn-v69oj"
                @click="routeBack"
              >
                {{ $t('payeeDetails.back') }}
              </v-btn>
              <v-btn
                v-if="(config.paymentSystem === 'UKFPS' && isAddDeletePayeePermitted.ukfps) || (isAddDeletePayeePermitted.sepa && config.paymentSystem === 'STEP2')"
                text
                :color="primaryColor"
                class="text-none py-2 px-4"
                data-qa="payeedetails-btn-k5p5k3"
                @click="onDeletePayee"
              >
                {{ appSettings.enableNominatedAccountFeatures ? $t('common.delete') : $t('payeeDetails.deletePayee') }}
              </v-btn>
              <v-btn
                v-if="isTransferFundsPermitted"
                dark
                :color="primaryColor"
                class="text-none py-2 px-4"
                data-qa="payeedetails-btn-p5q4"
                @click="transferFunds"
              >
                {{ $t('payeeDetails.transferFunds') }}
              </v-btn>
            </v-card-actions>
            <!-- Form Actions End -->
          </v-card>
          <!-- Form End -->
        </v-flex>
      </v-layout>
      <!-- Confirmation modal - Delete Payee -->
      <Modal
        v-if="showDeleteConfirmationModal"
        :config="getDeletePayeeModalConfig"
        :is-delete-button="true"
        @btn2Action="onCancel"
        @btn1Action="onDeletePayeeConfirm"
      />
    </v-flex>
    <!-- Successful modal to Delete Payee -->
    <Modal
      v-if="isDeletePayeeSuccessful"
      :config="getDeletePayeeSuccessConfig"
      @btn1Action="routeToPayeeList"
    />
    <!-- Nominated Account Details Modal -->
    <Modal
      v-if="showNominatedAccDetails && nominatedAccDetails"
      :config="modalConfig.nominatedAccDetails"
      @btn2Action="modalConfig.nominatedAccDetails.enabled = false"
    >
      <span slot="modalContent" class="font-weight-bold" data-qa="payeedetails-span-wtbltq">
        <v-flex v-if="nominatedAccDetails.module === 'CASA'" data-qa="payeedetails-flex-0yougr">
          <v-flex class="py-2" data-qa="payeedetails-flex-d5caq7">
            <font class="overline subheading-1 font-weight-bold">
              {{ nominatedAccDetails.accountDescription }}
            </font> <br data-qa="payeedetails-br-0o06qb">
            {{ nominatedAccDetails.accountId }}
          </v-flex>
          <v-flex class="py-2" data-qa="payeedetails-flex-enjgve">
            <font class="overline subheading-1 font-weight-bold">
              {{ $t('payeeDetails.sortCode') }}
            </font> <br data-qa="payeedetails-br-szr6tm">
            {{ defaultConfigurationsSortCode }}
          </v-flex>
        </v-flex>
        <v-flex v-else data-qa="payeedetails-flex-don1na">
          <v-flex class="py-2" data-qa="payeedetails-flex-vvnjoq">
            <font class="overline subheading-1 font-weight-bold">
              {{ nominatedAccDetails.productDescription }}
            </font> <br data-qa="payeedetails-br-j0y0k1">
            {{ nominatedAccDetails.fixedDepositAccountId }}
          </v-flex>
          <v-flex class="py-2" data-qa="payeedetails-flex-70ph1">
            <font class="overline subheading-1 font-weight-bold">
              {{ $t('payeeDetails.fundingAccountLabel') }}
            </font> <br data-qa="payeedetails-br-t30nwo">
            {{ nominatedAccDetails.fundingAccountId }}
          </v-flex>
          <v-flex class="py-2" data-qa="payeedetails-flex-v3usvu">
            <font class="overline subheading-1 font-weight-bold">
              {{ $t('payeeDetails.maturityAccountLabel') }}
            </font> <br data-qa="payeedetails-br-skn3e">
            {{ getMaturityAccount() }}
          </v-flex>
        </v-flex>
      </span>
    </Modal>
    <!-- OTP Section for Delete Payee -->
    <Modal
      v-if="showOTPScreen"
      :config="otpModalConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="payeedetails-span-6n0jre">
        <OtpInput :otp-config="otpSettings" />
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import '@/styles/pages/payee.scss'
import store from '@/core/store'
import commonService from '@/service/commonService.js'
import event from '@/util/event'
import getFormConfig from '@/util/formUtility.js'
import { rearrangeSchemaBySequence } from '@/composables/useSchemaUtils'

export default {
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue'),
    PayeeRelatedDocuments: () => import('./PayeeRelatedDocuments.vue')
  },
  beforeRouteEnter (to, from, next) {
    next()
  },
  data () {
    return {
      config: {},
      showNominatedAccDetails: false,
      nominatedAccDetails: {},
      showDeleteConfirmationModal: false,
      showOTPScreen: false,
      isDeletePayeeSuccessful: false,
      ownLinkedAccounts: [],
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      defaultConfigurationsSortCode: this.$appSettings.defaultConfigurations.sortCode,
      enableOTPToDeletePayee:
        this.$appSettings.defaultConfigurations.enableOTPManagePayee.deletePayee,
      otpModalConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        btn2Label: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      modalConfig: {
        confirmDeletePayee: {
          enabled: true,
          persistent: true,
          body: this.$t('payeeDetails.confirmSubtitle'),
          btn2Label: this.$t('recurringAndFuturePayments.cancel'),
          btn1Label: this.$t('recurringAndFuturePayments.delete'),
          width: 400
        },
        deletePayeeSuccess: {
          enabled: true,
          persistent: true,
          body: this.$t('payeeDetails.subtitle'),
          btn1Label: this.$t('common.okay'),
          width: 600
        },
        nominatedAccDetails: {
          enabled: true,
          persistent: true,
          title: this.$t('payeeDetails.linkedAccountsTitle'),
          btn2Label: this.$t('common.okay'),
          width: 600
        }
      },
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      schema: {
        beneficiaryDetails: { exists: true }
      },
      enableUDFBeneficiaryForAddPayee: this.$appSettings.defaultConfigurations.enableUDFBeneficiaryForAddPayee,
      isTransferFundsPermitted: false,
      isAddDeletePayeePermitted: {
        sameBank: false,
        ukfps: false,
        sepa: false
      },
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      selectedPayeeDetails: null,
      payeeDocuments: null,
      listCountryCodes: [],
      payeeAddressDetailsConfig: {},
      udfGenericCodes: {}
    }
  },
  computed: {
    getDeletePayeeModalConfig () {
      return {
        ...this.modalConfig.confirmDeletePayee,
        title: this.appSettings.enableNominatedAccountFeatures && this.config.ownAccount
          ? `${this.$t('payeeDetails.deleteNominatedAccConfirmation')} ${this.config.accNo}?`
          : this.$t('payeeDetails.deletePayeeConfirmation')
      }
    },
    getDeletePayeeSuccessConfig () {
      return {
        ...this.modalConfig.deletePayeeSuccess,
        title: this.$t('payee.successDeleteMsg', { name: this.config.name })
      }
    },
    shouldDisplayRelatedDocuments () {
      return this.selectedPayeeDetails.paymentSystem === 'STEP2' && this.isSmeLogin
    },
    udfDetails () {
      const additionalProperties = this.selectedPayeeDetails?.['custom-fields']?.additionalProperties ?? {}
      const { schema = {} } = this.schema?.beneficiaryDetails ?? {}

      return Object.keys(schema)
        .map((field) => ({
          key: field,
          label: schema[field]?.label ?? field,
          value: this.getGenCodeText(field, additionalProperties[field])
        }))
        .filter(item => item.value !== null && item.value !== undefined && item.value !== '')
    },
    isAddPayeeAddressEnabled () {
      return this.appSettings.enableInternationalPayeeAddressFields && this.isSmeLogin
    }
  },
  watch: {
    showOTPScreen () {
      if (this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 500)
      }
    }
  },
  async created () {
    this.modalConfig.confirmDeletePayee.btn1Color = this.errorColor
    this.modalConfig.confirmDeletePayee.btn2Color = this.errorColor

    const selectedAccount = store.getters['profileStore/profileData'].selectedPayeeDetails
    this.getPayeeAddressDetailsFormConfig()

    this.selectedPayeeDetails = selectedAccount

    await this.mapUDFBeneficiaryForm()
    await this.setUdfGenericCodes()

    if (selectedAccount && selectedAccount.name && selectedAccount.paymentSystem !== 'SWIFT') {
      this.payeeDocuments = await commonService.searchDocuments({
        businessType: 'DOMESTIC-BENEFICIARY',
        businessValue: this.selectedPayeeDetails.beneficiaryId
      })
      this.config = {
        name: selectedAccount.name,
        fullName: selectedAccount.name,
        accNo: selectedAccount.accountIdentification,
        currency: selectedAccount.currency,
        sortCode: selectedAccount.bankIdentifier,
        beneficiaryID: selectedAccount.beneficiaryId,
        paymentSystem: selectedAccount.paymentSystem,
        ownAccount: selectedAccount.ownAccount,
        addressType: selectedAccount.addressType,
        addressLine: selectedAccount.addressLine,
        buildingNumber: selectedAccount.buildingNumber,
        street: selectedAccount.street,
        postalCode: selectedAccount.postalCode,
        city: selectedAccount.city,
        countrySubDivision: selectedAccount.countrySubDivision,
        country: selectedAccount.country
      }

      // Only for SME - Check if the selected account has delete permissions
      const permissions = store.getters['profileStore/profileData']?.permissions

      this.isAddDeletePayeePermitted.sameBank = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('ADD_AND_DELETE_SAME_BANK_PAYEES') : true
      this.isAddDeletePayeePermitted.ukfps = ((this.isSmeLogin && this.enableRoleBasedAccess) && (this.config.paymentSystem === 'UKFPS')) ? permissions?.includes('ADD_AND_DELETE_UKFPS_PAYEES') : true
      this.isAddDeletePayeePermitted.sepa = ((this.isSmeLogin && this.enableRoleBasedAccess) && (this.config.paymentSystem === 'STEP2')) ? permissions?.includes('ADD_AND_DELETE_SEPA_PAYEES') : true
      this.isTransferFundsPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('TRANSFER_FUNDS') : true

      this.getLinkedAccounts(selectedAccount.beneficiaryId)
    } else if (selectedAccount.paymentSystem === 'SWIFT') {
      this.payeeDocuments = await commonService.searchDocuments({
        businessType: 'SWIFT-BEN',
        businessValue: this.selectedPayeeDetails.beneficiaryId
      })
      this.config = {
        name: selectedAccount.name,
        fullName: selectedAccount.name,
        accNo: selectedAccount.beneficiaryAccountNumber,
        currency: selectedAccount.currency,
        sortCode: selectedAccount.beneficiaryBankBic,
        beneficiaryID: selectedAccount.beneficiaryId,
        paymentSystem: selectedAccount.paymentSystem,
        country: selectedAccount.ctry,
        town: selectedAccount.twnNm,
        postCode: selectedAccount.pstCd
      }
      // Only for SME - Check if the selected account has delete permissions
      const permissions = store.getters['profileStore/profileData']?.permissions
      this.isTransferFundsPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('TRANSFER_FUNDS') : true
    }
    this.getGenericCodes()
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && this.showOTPScreen) {
        this.otpModalConfig.enabled = false
        this.deletePayee()
      } else {
        this.otpModalConfig.enableSave = true
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.otpModalConfig.enableSave = true
    })
  },
  beforeDestroy () {
    store.dispatch('profileStore/setProfileData', {
      selectedPayeeDetails: ''
    })
    event.$off('IS_OTP_VALID')
  },
  methods: {
    routeBack () {
      store.dispatch('profileStore/setProfileData', {
        selectedPayeeDetails: ''
      })
      this.$router.push({ name: 'Payee', params: { accountType: 'otherBank', returnToTab: this.$route.params.comingFromTab || 0 } })
    },
    transferFunds () {
      if (this.config) {
        store.dispatch('profileStore/setProfileData', {
          selectedPayeeDetails: ''
        })
        this.$router.push({
          name: this.config.paymentSystem === 'SWIFT' ? 'Swift Payments' : this.config.paymentSystem === 'STEP2' ? 'InternationalPayments' : 'DomesticPayments',
          params: {
            payeeAccountNumber: this.config.accNo,
            payeeName: this.config.name,
            payeeSortCode: this.config.sortCode,
            payeeAccount: this.config
          }
        })
      }
    },
    async getGenericCodes () {
      const code = {
        codeReferences: [{ reference: 'ISOCountryCode2Char' }]
      }
      const response = await commonService.getGenericCodes(code)
      if (response && response.aggregateCodes && response.aggregateCodes[0]) {
        if (response.aggregateCodes[0].codes) {
          this.listCountryCodes = response.aggregateCodes[0].codes
        }
      }
    },
    getCountryDesciption (code) {
      const country = this.listCountryCodes.find(item => item.codeReference === code)
      return country ? country.codeDescription : ''
    },
    onDeletePayee () {
      this.showDeleteConfirmationModal = true
      this.modalConfig.confirmDeletePayee.enabled = true
    },
    onDeletePayeeConfirm () {
      this.showDeleteConfirmationModal = false
      this.modalConfig.confirmDeletePayee.enabled = false
      if (this.ownLinkedAccounts && this.ownLinkedAccounts.length) {
        this.restrictDeleteNA()
      } else {
        if (this.enableOTPToDeletePayee) {
          this.otpModalConfig.enabled = true
          this.showOTPScreen = true
        } else {
          this.deletePayee()
        }
      }
    },
    routeToPayeeList () {
      store.dispatch('profileStore/setProfileData', {
        selectedPayeeDetails: ''
      })
      this.isDeletePayeeSuccessful = false
      // check for the beneficiary tab (same/others) idx from route params so after delete we can go back to the same tab
      this.$router.push({ name: 'Payee', params: { returnToTab: this.$route.params.comingFromTab || 0 } })
    },
    restrictDeleteNA () {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: this.$t('common.error'),
          content: this.$t('payeeDetails.deleteNAwithLinkedAccErrorMsg'),
          type: 'error',
          saveButton: this.$t('common.okay'),
          width: 450,
          icon: '',
          component: 'dob-modal'
        }
      })
    },
    async deletePayee () {
      const response = this.selectedPayeeDetails?.documentDetails?.length > 0
        ? await commonService.deletePayeeAndDocuments({
          beneficiaryId: this.selectedPayeeDetails.beneficiaryId,
          documentDetails: this.selectedPayeeDetails.documentDetails
        })
        : await commonService.deleteInterBankBeneficiary(this.selectedPayeeDetails.beneficiaryId)
      if (!response.causes && response.status !== 401) {
        this.isDeletePayeeSuccessful = true
      } else {
        // Error Modal for Deleting or amending Nominated Accounts that is linked to accounts
        if (response.causes && response.causes.length && response.causes[0].code === '20600426') {
          event.$emit('reset_OTPField', true)
          this.restrictDeleteNA()
        }
      }
      this.showDeleteConfirmationModal = false
    },
    onOtpModalClose () {
      this.otpModalConfig.enabled = false
      this.showOTPScreen = false
    },
    async viewLinkedAccountDetails (account) {
      let response
      if (account.module === 'CASA') {
        response = await commonService.getAccountDetails(account.moduleReference)
        if (response && !response.causes) {
          this.showNominatedAccDetails = this.modalConfig.nominatedAccDetails.enabled = true
          this.nominatedAccDetails = response
          this.nominatedAccDetails.module = account.module
        }
      } else {
        response = await commonService.getFixedDepositDetails(
          account.moduleReference
        )
        if (response && response.customerId) {
          this.showNominatedAccDetails = this.modalConfig.nominatedAccDetails.enabled = true
          this.nominatedAccDetails = response
          this.nominatedAccDetails.module = account.module
        }
      }
    },
    async getLinkedAccounts (accountId) {
      const response = await commonService.getLinkedAccounts(accountId)
      if (response && !response.causes) this.ownLinkedAccounts = response.beneficiaryLinkages
    },
    getAccountName  (accountType) {
      switch (accountType) {
        case 'DEPOSIT ACCOUNT':
          return this.$t('payeeDetails.depositAccountsLabel')
        case 'CASA':
          return this.$t('payeeDetails.savingAccountsLabel')
        default:
          break
      }
    },
    getMaturityAccount () {
      if (this.nominatedAccDetails.allowPayAwaytoOtherBank) {
        const externalPayAwayAccLength = this.nominatedAccDetails.payCapitalToAccount && this.nominatedAccDetails.payCapitalToAccount.length ? this.nominatedAccDetails.payCapitalToAccount.split(
          '-'
        ) : ''
        const externalPayAwayAccount =
          externalPayAwayAccLength.length > 1
            ? this.nominatedAccDetails.payCapitalToAccount
            : this.nominatedAccDetails.payCapitalToAccount +
              ' - ' +
              this.nominatedAccDetails.capitalAccountBICId
        return externalPayAwayAccount
      } else return this.nominatedAccDetails.payCapitalToAccount
    },
    async mapUDFBeneficiaryForm () {
      if (this.enableUDFBeneficiaryForAddPayee) {
        // Step 1: Load form configuration from JSON
        const formConfig = getFormConfig(
          await commonService.getFormData(`UDF_AddBeneficiary-${this.$i18n.locale}`)
        )

        // Step 2: sort config schema based on sequence
        const sortedFormConfig = rearrangeSchemaBySequence(formConfig)

        // Step 3: Filter out excluded/hidden fields from schema (these will not be displayed)
        const filteredSchema = Object.fromEntries(
          Object.entries(sortedFormConfig.schema)
            .filter(([_, config]) => !config.excluded && !config.hidden)
        )

        // Step 4: Build model based on filtered schema
        const filteredModel = Object.fromEntries(
          Object.keys(filteredSchema).map(key => [key, ''])
        )

        this.schema.beneficiaryDetails = {
          schema: filteredSchema,
          model: filteredModel
        }
      }
    },
    findChildDescription (parentCode, childCode, data) {
      const parentChildren = data[parentCode]
      if (!parentChildren) return null

      // Direct child check
      if (parentChildren[childCode]) {
        return parentChildren[childCode].codeDescription
      }

      // Recursive check
      for (const key of Object.keys(parentChildren)) {
        const result = this.findChildDescription(key, childCode, data)
        if (result) return result
      }

      return null // Not found
    },
    getGenCodeText (field, value) {
      const { schema } = this.schema.beneficiaryDetails
      const { gcReferenceKey, dependsOn } = schema[field]

      if (gcReferenceKey == null || gcReferenceKey === '') { return value }

      if (gcReferenceKey === '$PARENT_VALUE') {
        return this.findChildDescription(dependsOn.parentField, value, this.udfGenericCodes
        ) || value
      }

      return this.udfGenericCodes[gcReferenceKey]?.[value]?.codeDescription || value
    },
    async getPayeeAddressDetailsFormConfig () {
      if (this.isAddPayeeAddressEnabled) {
        const form = getFormConfig(await commonService.getFormData(`PayeeAddressDetails-${this.$i18n.locale}`))
        this.payeeAddressDetailsConfig = form.schema
      }
    },
    onCancel () {
      this.showDeleteConfirmationModal = false
      this.modalConfig.confirmDeletePayee.enabled = false
    },
    async setUdfGenericCodes () {
      if (!this.enableUDFBeneficiaryForAddPayee) { return }

      const { schema } = this.schema.beneficiaryDetails

      const getGenericCodes = async (codeReferences) => {
        const { aggregateCodes = [] } = await commonService.getGenericCodes({ codeReferences })
        if (aggregateCodes.length > 0) {
          return Object.fromEntries(
            aggregateCodes
              .filter(ref => ref.reference)
              .map(ref => [
                ref.reference,
                Object.fromEntries(ref.codes.map(code => [
                  code.codeReference,
                  code
                ]))
              ]))
        }
        return {}
      }

      // Step 1: get REFERENCE codes for NON dynamic generic codes
      const codeReferences = Object.entries(schema)
        .filter(([, config]) => config.gcReferenceKey && config.gcReferenceKey !== '$PARENT_VALUE')
        .map(([, config]) => ({ reference: config.gcReferenceKey }))

      // Step 2: get GENERIC codes for NON dynamic generic codes
      const parentGenericCodes = await getGenericCodes(codeReferences)

      // Step 3: map list of child-parent pair
      const children = Object.fromEntries(
        Object.entries(schema)
          .filter(([_, config]) => config.dependsOn?.parentField && config.gcReferenceKey === '$PARENT_VALUE')
          .map(([field, config]) => [field, config.dependsOn.parentField])
      )

      // Step 4: get REFERENCE codes for parent fields of dynamic generic codes
      const parentCodeReferences = []
      const processedParents = new Set()

      Object.entries(children).forEach(([_, parentRef]) => {
        if (!parentRef || processedParents.has(parentRef)) { return }
        processedParents.add(parentRef)

        const parentCodes = parentGenericCodes[parentRef]
        if (!parentCodes) { return }

        Object.entries(parentCodes).forEach(([codeRef]) => {
          parentCodeReferences.push({ reference: codeRef })
        })
      })

      // Step 5: get GENERIC codes for parent fields of dynamic generic codes
      const childGenericCodes = await getGenericCodes(parentCodeReferences)

      this.udfGenericCodes = {
        ...parentGenericCodes,
        ...childGenericCodes
      }
    }
  }
}
</script>
